import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const financePurchaseList = createAsyncThunk(
  'finance-purchase-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}finance-purchase/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeFinancePurchase = createAsyncThunk(
  'finance-purchase-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}finance-purchase/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getFinancePurchaseById = createAsyncThunk(
  'finance-purchase-get',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}finance-purchase/edit/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const approveFinancePurchase = createAsyncThunk(
  'finance-purchase-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}finance-purchase/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewFinancePurchase = createAsyncThunk(
  'finance-purchase-view',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}finance-purchase/view/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

type PurchaseState = {
  errors: any
}

const initialState: PurchaseState = {
  errors: '',
}

export const financePurchaseSlice = createSlice({
  name: 'finance-purchase',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeFinancePurchase.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = financePurchaseSlice.actions
export default financePurchaseSlice.reducer
